module.exports = __webpack_public_path__ + "static/media/gas and oil.0a06e5e1.jpg";